<div class="mybets-scoreboard_timer">{{ timer }}</div>
